import axios from 'axios';

import { apiBaseUrl } from '../config/api_config';

// The public site only consumes unauthenticated `public/*` endpoints, so the
// instance stays lean: a shared base URL and a generous timeout for media.
const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 60000,
});

export default axiosInstance;
